interface WizardStepperProps {
  steps: string[];
  currentStep: number;
  onStepClick: (step: number) => void;
}

export function WizardStepper({ steps, currentStep, onStepClick }: WizardStepperProps) {
  return (
    <div className="flex items-center gap-0 select-none">
      {steps.map((label, i) => {
        const isCompleted = i < currentStep;
        const isActive = i === currentStep;
        const isFuture = i > currentStep;

        return (
          <div key={i} className="flex items-center">
            {/* Connector line */}
            {i > 0 && (
              <div
                className="transition-colors duration-300"
                style={{
                  width: '32px',
                  height: '2px',
                  background: isCompleted || isActive
                    ? '#7c5cfc'
                    : 'rgba(255,255,255,0.08)',
                }}
              />
            )}

            {/* Step pill */}
            <button
              onClick={() => isCompleted && onStepClick(i)}
              disabled={isFuture}
              className="flex items-center gap-2 py-1.5 px-1.5 rounded-full transition-all duration-200"
              style={{
                cursor: isCompleted ? 'pointer' : 'default',
                background: isActive
                  ? 'rgba(124, 92, 252, 0.1)'
                  : 'transparent',
              }}
            >
              <div
                className="flex items-center justify-center w-6 h-6 rounded-full text-[0.65rem] font-bold shrink-0 transition-all duration-300"
                style={{
                  background: isActive
                    ? 'linear-gradient(135deg, #7c5cfc, #5b4fd4)'
                    : isCompleted
                      ? 'rgba(124, 92, 252, 0.2)'
                      : 'rgba(255,255,255,0.05)',
                  border: isActive
                    ? '2px solid rgba(124, 92, 252, 0.5)'
                    : isCompleted
                      ? '2px solid rgba(124, 92, 252, 0.25)'
                      : '2px solid rgba(255,255,255,0.08)',
                  color: isActive
                    ? '#fff'
                    : isCompleted
                      ? '#a78bfa'
                      : 'rgba(255,255,255,0.2)',
                  boxShadow: isActive
                    ? '0 0 10px rgba(124, 92, 252, 0.3)'
                    : 'none',
                }}
              >
                {isCompleted ? '✓' : i + 1}
              </div>
              <span
                className="text-[0.68rem] font-semibold tracking-wide whitespace-nowrap pr-1 hidden sm:block transition-colors duration-300"
                style={{
                  color: isActive
                    ? '#a78bfa'
                    : isCompleted
                      ? 'rgba(167, 139, 250, 0.7)'
                      : 'rgba(255,255,255,0.2)',
                }}
              >
                {label}
              </span>
            </button>
          </div>
        );
      })}
    </div>
  );
}
